/**
 * Specifies the File Manager internal ID's
 */
/** @hidden */
export const ITEM_VERTICAL_CENTER = 'e-ribbon-vertical-center';
/** @hidden */
export const EXPAND_COLLAPSE_ICON = 'e-icons e-drop-icon';
/** @hidden */
export const BACKSTAGE_CLOSE_ICON = 'e-icons e-arrow-left';
/** @hidden */
export const OVERFLOW_ICON = 'e-icons e-more-horizontal-1';
/** @hidden */
export const VERTICAL_DDB = 'e-vertical';
/** @hidden */
export const DISABLED_CSS = 'e-disabled';
/** @hidden */
export const RTL_CSS = 'e-rtl';
/** @hidden */
export const RIBBON_HOVER = 'e-ribbon-hover';
/** @hidden */
export const RIBBON_CONTROL = 'e-ribbon-control';
/** @hidden */
export const RIBBON_POPUP_CONTROL = 'e-ribbon-popup-control';
/** @hidden */
export const RIBBON_POPUP_OPEN = 'e-ribbon-open';
/** @hidden */
export const RIBBON_KEYTIP = 'e-ribbon-keytip';
/** @hidden */
export const SPACE = ' ';
/** @hidden */
export const HORIZONTAL_SCROLLBAR = 'e-hscroll-bar';
/** @hidden */
export const HIDE_CSS = 'e-ribbon-hide';
/** @hidden */
export const RIBBON_TAB = 'e-ribbon-tab';
/** @hidden */
export const RIBBON_CONTEXTUAL_TAB = 'e-ribbon-contextual-tab';
/** @hidden */
export const RIBBON_TAB_ACTIVE = 'e-ribbon-active';
/** @hidden */
export const RIBBON_TAB_ITEM = 'e-ribbon-tab-item';
/** @hidden */
export const RIBBON_COLLAPSE_BUTTON = 'e-ribbon-collapse-btn';
/** @hidden */
export const RIBBON_EXPAND_BUTTON = 'e-ribbon-expand-btn';
/** @hidden */
export const RIBBON_COLLAPSIBLE = 'e-ribbon-collapsible';
/** @hidden */
export const RIBBON_OVERALL_OF_BUTTON = 'e-ribbon-overall-of-btn';
/** @hidden */
export const RIBBON_GROUP_OF_BUTTON = 'e-ribbon-group-of-btn';
/** @hidden */
export const RIBBON_OVERFLOW_TARGET = 'e-ribbon-overflow-target';
/** @hidden */
export const RIBBON_OVERFLOW = 'e-ribbon-overflow';
/** @hidden */
export const TAB_CONTENT = 'e-content';
/** @hidden */
export const RIBBON_MINIMIZE = 'e-ribbon-minimize';
/** @hidden */
export const RIBBON_GROUP = 'e-ribbon-group';
/** @hidden */
export const RIBBON_SINGLE_BUTTON_SELECTION = 'e-ribbon-single-selection';
/** @hidden */
export const RIBBON_MULTIPLE_BUTTON_SELECTION = 'e-ribbon-multiple-selection';
/** @hidden */
export const RIBBON_GROUP_BUTTON = 'e-ribbon-group-button';
/** @hidden */
export const RIBBON_GROUP_BUTTON_OVERFLOW_POPUP = 'e-ribbon-group-button-overflow-popup';
/** @hidden */
export const RIBBON_GROUP_BUTTON_CONTENT = 'e-ribbon-group-button-content';
/** @hidden */
export const RIBBON_GROUP_CONTAINER = 'e-ribbon-group-container';
/** @hidden */
export const RIBBON_OF_TAB_CONTAINER = 'e-ribbon-of-tab';
/** @hidden */
export const RIBBON_OF_GROUP_CONTAINER = 'e-ribbon-of-group-container';
/** @hidden */
export const RIBBON_GROUP_CONTENT = 'e-ribbon-group-content';
/** @hidden */
export const RIBBON_GROUP_HEADER = 'e-ribbon-group-header';
/** @hidden */
export const RIBBON_OVERFLOW_HEADER = 'e-ribbon-overflow-header';
/** @hidden */
export const RIBBON_GROUP_OVERFLOW = 'e-ribbon-group-overflow';
/** @hidden */
export const RIBBON_GROUP_OVERFLOW_DDB = 'e-ribbon-group-overflow-ddb';
/** @hidden */
export const RIBBON_LAUNCHER = 'e-ribbon-launcher';
/** @hidden */
export const RIBBON_LAUNCHER_ICON_ELE = 'e-ribbon-launcher-icon';
/** @hidden */
export const RIBBON_LAUNCHER_ICON = 'e-icons e-launcher';
/** @hidden */
export const RIBBON_COLLECTION = 'e-ribbon-collection';
/** @hidden */
export const RIBBON_ITEM = 'e-ribbon-item';
/** @hidden */
export const RIBBON_ROW = 'e-ribbon-row';
/** @hidden */
export const RIBBON_COLUMN = 'e-ribbon-column';
/** @hidden */
export const RIBBON_LARGE_ITEM = 'e-ribbon-large-item';
/** @hidden */
export const RIBBON_MEDIUM_ITEM = 'e-ribbon-medium-item';
/** @hidden */
export const RIBBON_SMALL_ITEM = 'e-ribbon-small-item';
/** @hidden */
export const RIBBON_CONTENT_HEIGHT = 'e-ribbon-content-height';
/** @hidden */
export const DROPDOWNBUTTON = 'e-dropdown-btn';
/** @hidden */
export const DROPDOWNBUTTON_HIDE = 'e-caret-hide';
/** @hidden */
export const RIBBON_TEMPLATE = 'e-ribbon-template';
/** @hidden */
export const RIBBON_HELP_TEMPLATE = 'e-ribbon-help-template';
/** @hidden */
export const RIBBON_TOOLTIP = 'e-ribbon-tooltip';
/** @hidden */
export const RIBBON_TOOLTIP_TARGET = 'e-ribbon-tooltip-target';
/** @hidden */
export const RIBBON_TOOLTIP_TITLE = 'e-ribbon-tooltip-title';
/** @hidden */
export const RIBBON_TOOLTIP_CONTENT = 'e-ribbon-tooltip-content';
/** @hidden */
export const RIBBON_TOOLTIP_ICON = 'e-ribbon-tooltip-icon';
/** @hidden */
export const RIBBON_TOOLTIP_CONTAINER = 'e-ribbon-tooltip-container';
/** @hidden */
export const RIBBON_TEXT_CONTAINER = 'e-ribbon-text-container';
/** @hidden */
export const RIBBON_SIMPLIFIED_MODE = 'e-ribbon-simplified-mode';
/** @hidden */
export const RIBBON_BACKSTAGE_POPUP = 'e-ribbon-backstage-popup';
/** @hidden */
export const RIBBON_BACKSTAGE_OPEN = 'e-ribbon-backstage-open';
/** @hidden */
export const RIBBON_BACKSTAGE_CONTENT = 'e-ribbon-backstage-content';
/** @hidden */
export const RIBBON_SELECTED_CONTENT = 'e-ribbon-selected-content';
/** @hidden */
export const RIBBON_BACKSTAGE = 'e-ribbon-backstage';
/** @hidden */
export const RIBBON_BACKSTAGE_MENU = 'e-ribbon-backstage-menu';
/** @hidden */
export const RIBBON_BACKSTAGE_TEMPLATE = 'e-ribbon-backstage-template';
/** @hidden */
export const RIBBON_BACKSTAGE_MENU_WRAPPER = 'e-ribbon-backstage-wrapper';
/** @hidden */
export const RIBBON_BACKSTAGE_ITEMS_WRAPPER = 'e-ribbon-backstage-items-wrapper';
/** @hidden */
export const RIBBON_BACKSTAGE_TEXT_MENU = 'e-blankicon';
/** @hidden */
export const TAB_ID = '_tab';
/** @hidden */
export const GROUP_ID = '_group';
/** @hidden */
export const COLLECTION_ID = '_collection';
/** @hidden */
export const ITEM_ID = '_item';
/** @hidden */
export const COLLAPSE_BUTTON_ID = '_collapsebutton';
/** @hidden */
export const OVRLOF_BUTTON_ID = '_sim_ovrl_overflow';
/** @hidden */
export const GROUPOF_BUTTON_ID = '_sim_grp_overflow';
/** @hidden */
export const HEADER_ID = '_header';
/** @hidden */
export const LAUNCHER_ID = '_launcher';
/** @hidden */
export const CONTENT_ID = '_content';
/** @hidden */
export const CONTAINER_ID = '_container';
/** @hidden */
export const OVERFLOW_ID = '_overflow';
/** @hidden */
export const DROPDOWN_ID = '_dropdown';
/** @hidden */
export const RIBBON_FILE_MENU_ID = '_filemenu';
/** @hidden */
export const RIBBON_BACKSTAGE_MENU_ID = '_backstage';
/** @hidden */
export const RIBBON_BACKSTAGE_POPUP_ID = '_backstagepopup';
/** @hidden */
export const RIBBON_FILE_MENU_LIST = '_filemenulist';
/** @hidden */
export const RIBBON_MENU_LIST = '_menulist';
/** @hidden */
export const RIBBON_FOOTER_MENU_LIST = '_footermenulist';
/** @hidden */
export const RIBBON_HELP_PANE_TEMPLATE_ID = '_helppanetemplate';
/** @hidden */
export const RIBBON_GROUP_BUTTON_ID = '_grpbtn';
/** @hidden */
export const RIBBON_KEYTIP_ID = '_keytip';
/** @hidden */
export const RIBBON_FILE_MENU_WIDTH = '--fileMenuWidth';
/** @hidden */
export const RIBBON_HELP_PANE_TEMPLATE_WIDTH = '--helpTemplateWidth';
